import React, { useState, ReactElement, cloneElement } from 'react';
import { Lock } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '../../components/ui/tooltip';
import { useIsAdmin } from './authStore';
import { UnlockModal } from './UnlockModal';
import { cn } from '../../lib/utils';

interface ProtectedActionProps {
  children: ReactElement<{ disabled?: boolean; className?: string; onClick?: () => void }>;
  tooltip?: string;
  showLockIcon?: boolean;
}

/**
 * Wrapper component that disables child element when not in admin mode.
 * When clicked in browser mode, it opens the unlock modal.
 */
export function ProtectedAction({
  children,
  tooltip = '需要管理员权限',
  showLockIcon = true,
}: ProtectedActionProps) {
  const [unlockModalOpen, setUnlockModalOpen] = useState(false);
  const isAdmin = useIsAdmin();

  if (isAdmin) {
    return children;
  }

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setUnlockModalOpen(true);
  };

  const childProps = children.props;

  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            className="relative inline-flex cursor-not-allowed"
            onClick={handleClick}
          >
            {cloneElement(children, {
              disabled: true,
              className: cn(
                childProps.className,
                'pointer-events-none opacity-50'
              ),
            } as any)}
            {showLockIcon && (
              <div className="absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center rounded-full bg-muted">
                <Lock className="h-2.5 w-2.5 text-muted-foreground" />
              </div>
            )}
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>{tooltip}</p>
        </TooltipContent>
      </Tooltip>
      <UnlockModal open={unlockModalOpen} onOpenChange={setUnlockModalOpen} />
    </>
  );
}
